/**
 * This file is the entry point for all commands.
 * Commands use the CustomEvent API to communicate with Help!
 * Help is a command pallette for searching PennyLane AI's content (https://pennylane.ai/).
 * Content includes: Blog posts, Demos, Coding Challenges, Profiles, and more.
 */

export const COMMANDS = {
  OPEN_COMMAND_PALETTE: 'command-palette:open',
  CLOSE_COMMAND_PALETTE: 'command-palette:close',
}

export const closeCommandPalette = () => {
  window.postMessage(COMMANDS.CLOSE_COMMAND_PALETTE, "*");
};

export const openCommandPalette = () => {
  window.postMessage(COMMANDS.OPEN_COMMAND_PALETTE, "*");
};

/**
 * Command Logger
 * @param event MessageEvent
 */
export const commandLogger = (event: MessageEvent) => {
  console.log("Command:", {
    type: event.type,
    detail: event.data,
    origin: event.origin,
  });
};
